<amplify-authenticator [hide]="['SignUp', 'SignIn', 'Greetings', 'ForgotPassword', 'RequireNewPassword']" [usernameAttributes]="'email'">
</amplify-authenticator>
<div *ngIf="authState == 'forgotPassword'">
    <p>Reset your password</p>
    <p *ngIf="!sentCode">Enter your email address to receive a verification code.</p>
    <div class="form-group" *ngIf="!sentCode">
        <label for="username" class="h6 h6-responsive">Email * </label>
        <input class="form-control login-username" type="text" id="username" name="username" [(ngModel)]="username"
            placeholder="Email..." />
    </div>
    <div class="form-group" *ngIf="!sentCode">
        <button class="btn btn-primary login-btn" [disabled]="isAuthenticating"
            (click)="sendForgotPasswordCode($event)">Submit</button>
        <app-spin-icon *ngIf="isAuthenticating"></app-spin-icon>
    </div>
    <div class="form-group" *ngIf="sentCode">
        <label for="username" class="h6 h6-responsive">Confirmation Code * </label>
        <input class="form-control login-password-code" type="text" id="forgotPasswordCode" name="forgotPasswordCode"
            [(ngModel)]="forgotPasswordCode" placeholder="Code..." />
    </div>
    <div class="form-group" *ngIf="sentCode">
        <label for="forgotPasswordNewPassword" class="h6 h6-responsive">New Password * </label>
        <input class="form-control login-password" type="password" id="forgotPasswordNewPassword"
            name="forgotPasswordNewPassword" [(ngModel)]="newPassword" placeholder="New Password..." />
    </div>
    <div *ngIf="sentCode" class="text-left">
        <p class="p-0 m-0">Your new password must</p>
        <ul>
            <li>be at least 8 characters long</li>
            <li>have one uppercase letter</li>
            <li>have one lowercase letter</li>
            <li>have one number</li>
        </ul>
    </div>
    <div class="form-group" *ngIf="sentCode">
        <button class="btn btn-primary login-btn" [disabled]="isAuthenticating"
            (click)="submitForgotPassword()">Verify</button>
        <app-spin-icon *ngIf="isAuthenticating"></app-spin-icon>
    </div>
    <div class="form-group" *ngIf="sentCode">
        <a (click)="sendForgotPasswordCode($event)" class="link" href="">Resend Code</a>
    </div>
    <p *ngIf="sentCode">You didn't receive an email? Check your spam folders and try adding {{supportEmail}} to your
        contact list</p>
    <div class="form-group small" *ngIf="!sentCode">
        <a (click)="goBackToSignIn($event)" class="link" href="">Back to Sign In </a>
    </div>
</div>
<div *ngIf="authState == 'requireNewPassword'">
    <p>You are required to change your password</p>
    <div class="form-group">
        <label for="changePassword" class="h6 h6-responsive">New Password * </label>
        <input class="form-control login-password" type="password" id="changePassword"
            name="changePassword" [(ngModel)]="newPassword" placeholder="New Password..." />
    </div>
    <div class="text-left">
        <p class="p-0 m-0">Your new password must</p>
        <ul>
            <li>be at least 8 characters long</li>
            <li>have one uppercase letter</li>
            <li>have one lowercase letter</li>
            <li>have one number</li>
        </ul>
    </div>
    <div class="form-group">
        <a (click)="goBackToSignIn($event)" class="link" href="">Back to Sign In </a>
    </div>
    <div class="form-group">
        <button class="btn btn-primary login-btn" [disabled]="isAuthenticating"
            (click)="submitNewPassword()">Submit</button>
        <app-spin-icon *ngIf="isAuthenticating"></app-spin-icon>
    </div>
</div>
<div *ngIf="showSignIn">
    <div class="form-group">
        <label for="username" class="h6 h6-responsive">Email * </label>
        <input class="form-control login-username" type="text" id="username" name="username" [(ngModel)]="username"
            (keypress)="handleSubmit($event)" placeholder="Email..." />
    </div>
    <div class="form-group" class="h6 h6-responsive">
        <label for="password">Password * </label>
        <input class="form-control login-password" type="password" [(ngModel)]="password" id="password" name="password"
            (keypress)="handleSubmit($event)" placeholder="Password..." />
    </div>
    <div class="form-group small">
        <p>Forgot Password? <a (click)="triggerForgotPassword($event)" class="link login-reset-password" href="">Reset
                password</a></p>
    </div>
    <div class="form-group">
        <button class="btn btn-primary login-btn" [disabled]="isAuthenticating" (click)="login()">Login</button>
        <app-spin-icon *ngIf="isAuthenticating"></app-spin-icon>
    </div>
    <div class="form-group small" *ngIf="!disableRegistration">
        <p>Don't have an account? <a [routerLink]="['/register']">Register now</a></p>
    </div>
    <p class="small">By clicking “Login”, you agree to our <a target="_blank"
            [routerLink]="['/terms-and-conditions']">Terms of Service</a>, and <a target="_blank"
            [routerLink]="['/privacy']">Privacy Policy.</a></p>
</div>


// WEBPACK FOOTER //
// ./src/app/login/admin-login/admin-login.component.html